import styled, { css } from 'styled-components';

export const TooltipTip = styled.div`
  position: absolute;
  border-radius: 4px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px;
  color: var(--tooltip-text-color);
  font-size: 12px;
  line-height: 24px;
  background: var(--tooltip-background-color);
  z-index: 999;

  &:before {
    content: " ";
    left: 50%;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: var(--tooltip-arrow-size);
    margin-left: calc(var(--tooltip-arrow-size) * -1);
  }

  ${p => p.direction === 'top' && css`
    top: calc(var(--tooltip-margin) * -1);
    &:before {
      top: 100%;
      border-top-color: var(--tooltip-background-color);
    }
  `}

  ${p => p.direction === 'right' && css`
    left: calc(100% + var(--tooltip-margin));
    top: 50%;
    transform: translateX(0) translateY(-50%);
    &:before {
      left: calc(var(--tooltip-arrow-size) * -1);
      top: 50%;
      transform: translateX(0) translateY(-50%);
      border-right-color: var(--tooltip-background-color);
    }
  `}

  ${p => p.direction === 'bottom' && css`
    top: calc(100% + var(--tooltip-margin));
    &:before {
      bottom: 100%;
      border-bottom-color: var(--tooltip-background-color);
    }


    ${p?.offset && css`
        left: ${`${p?.offset === 'start' ? '-10px' : 'calc(100% + 10px)'}`};
        transform: ${`translate(${p?.offset === 'start' ? '0%' : '-100%'}, 0%)`};
        &:before {
          left: ${`${p?.offset === 'start' ? '10px' : 'calc(100% - 20px)'}`};
          margin-left: 0px;
        }
      `}
  `}

  ${p => p.direction === 'left' && css`
    left: auto;
    right: calc(100% + var(--tooltip-margin));
    top: 50%;
    transform: translateX(0) translateY(-50%);
    &:before {
      left: auto;
      right: calc(var(--tooltip-arrow-size) * -2);
      top: 50%;
      transform: translateX(0) translateY(-50%);
      border-left-color: var(--tooltip-background-color);
    }
  `}
`;
